// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2j6BT","content":"LoadingAlert_content__30o9u"};